export default __webpack_public_path__ + "static/media/addFolder.8c263cab.svg";